@if (alert) {
  <div
    class="alert-container"
    [attr.role]="ariaRole"
    aria-atomic="true"
    >
    @switch (alert.type) {
      @case (AlertType.Error) {
        <div class="alert-message error">
          <mat-icon class="icon icon-color-danger">error</mat-icon>
          <span>{{ alert.text }}</span>
        </div>
      }
      @case (AlertType.Success) {
        <div class="alert-message">
          <mat-icon class="icon icon-color-success">check_circle</mat-icon>
          <span>{{ alert.text }}</span>
        </div>
      }
    }
  </div>
}
